import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=22c738d0&scoped=true&"
import script from "./MultipleSelect.vue?vue&type=script&lang=js&"
export * from "./MultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=22c738d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c738d0",
  null
  
)

export default component.exports